import { action, makeObservable, observable } from 'mobx';
import { IPaginationLight } from '~/types/main';
import { defaultPaginationLight } from '~/constants/main';
import client from '~/services/client';
import logger from '~/services/logger';
import { TMessageCampaign } from '~/view/screens/MarketingScreen/screens/MessageCampaign/CampaignListScreen/types';

class MessageCampaignListStore {
  constructor() {
    makeObservable(this);
  }

  @observable pagination: IPaginationLight = defaultPaginationLight;
  @observable campaigns: TMessageCampaign[] = [];
  @observable filters: { search: string } = { search: '' };
  @observable loading = false;

  @action setFilters = (filters: { search: string }) => {
    this.filters = filters;
    this.fetchCampaigns(1, filters.search);
  };

  @action fetchCampaigns = async (page = 1, search = '') => {
    try {
      this.loading = true;
      const response = await client.get('v3/message_campaigns', { params: { page, per_page: 10, search } });
      this.pagination = response.data.pagination;
      this.campaigns = response.data.message_campaigns;
    } catch (error) {
      logger.error({ error, place: 'MessageCampaignsList', showModal: true });
    } finally {
      this.loading = false;
    }
  };

  @action deleteCampaign = async (id: number) => {
    try {
      this.loading = true;
      await client.delete(`v3/message_campaigns/${id}`);
      this.fetchCampaigns(this.pagination.current_page);
    } catch (error) {
      logger.error({ error, place: 'MessageCampaignsList deleteCampaign', showModal: true });
    } finally {
      this.loading = false;
    }
  };
}

export const messageCampaignListStore = new MessageCampaignListStore();
